import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Header,
  Segment,
  Form,
  Button,
  Message,
} from "semantic-ui-react";
import { User } from "../../../api";
import { useFormik } from "formik";
import * as Yup from "yup";

const userController = new User();

export function InviteComplete() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [isInvalid, setIsInvalid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    userController
      .getInviteByToken(token)
      .then((data) => {
        setUserData(data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsInvalid(true);
        setIsLoading(false);
      });
  }, [token]);

  const formik = useFormik({
    initialValues: { password: "", repeatPassword: "" },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Mínimo 8 caracteres")
        .matches(/[0-9]/, "Debe incluir al menos un número")
        .matches(/[a-z]/, "Debe incluir al menos una minúscula")
        .matches(/[A-Z]/, "Debe incluir al menos una mayúscula")
        .matches(/[^\w]/, "Debe incluir al menos un símbolo")
        .required("Campo obligatorio"),
      repeatPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Las contraseñas deben coincidir")
        .required("Campo obligatorio"),
    }),
    validateOnChange: false,
    onSubmit: async ({ password }) => {
      try {
        setError("");
        await userController.completeInvite(token, { password });
        navigate("/admin");
      } catch (err) {
        setError(err.msg || "Error al completar el registro");
      }
    },
  });

  if (isLoading) {
    return (
      <Container textAlign="center" style={{ marginTop: "5em" }}>
        <Segment loading placeholder />
      </Container>
    );
  }

  if (isInvalid || !userData) {
    return (
      <Container textAlign="center" style={{ marginTop: "5em" }}>
        <Segment placeholder>
          <Header as="h3" color="red">
            La invitación ha expirado o es inválida
          </Header>
        </Segment>
      </Container>
    );
  }

  return (
    <Container textAlign="center" style={{ marginTop: "3em", maxWidth: "480px" }}>
      <Segment stacked>
        <Header as="h2">Completar registro</Header>
        <p>
          Bienvenido a Sustemia,{" "}
          <strong>{userData.email}</strong>. Crea tu contraseña para acceder.
        </p>

        <Form onSubmit={formik.handleSubmit} style={{ textAlign: "left" }}>
          <Form.Field error={!!formik.errors.password}>
            <label>Contraseña</label>
            <input
              type="password"
              name="password"
              placeholder="Contraseña"
              value={formik.values.password}
              onChange={formik.handleChange}
            />
            {formik.errors.password && (
              <span style={{ color: "red", fontSize: "0.85em" }}>
                {formik.errors.password}
              </span>
            )}
          </Form.Field>

          <Form.Field error={!!formik.errors.repeatPassword}>
            <label>Repetir contraseña</label>
            <input
              type="password"
              name="repeatPassword"
              placeholder="Repetir contraseña"
              value={formik.values.repeatPassword}
              onChange={formik.handleChange}
            />
            {formik.errors.repeatPassword && (
              <span style={{ color: "red", fontSize: "0.85em" }}>
                {formik.errors.repeatPassword}
              </span>
            )}
          </Form.Field>

          {error && <Message negative content={error} />}

          <Button
            type="submit"
            primary
            fluid
            loading={formik.isSubmitting}
            style={{ marginTop: "1rem" }}
          >
            Activar cuenta
          </Button>
        </Form>

        <Message info style={{ marginTop: "1rem" }}>
          Si no esperabas esta invitación, cierra esta pestaña.
        </Message>
      </Segment>
    </Container>
  );
}
